module.exports = __webpack_public_path__ + "img/06.a27a332d.jpg";